"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultTimezone = exports.getDefaultCountry = exports.getDefaults = void 0;
const constants_1 = require("./constants");
const getDefaults = (locale) => {
    const locale_key = locale && locale in constants_1.LOCALE_DEFAULTS_BY_LOCALE ? locale : constants_1.DEFAULT_LOCALE;
    return constants_1.LOCALE_DEFAULTS_BY_LOCALE[locale_key];
};
exports.getDefaults = getDefaults;
/**
 * Get the default country code for a given locale.
 * Falls back to "US" if the locale is not found.
 *
 * @param locale - Optional locale string (e.g., "en_GB", "de_DE")
 * @returns ISO country code (e.g., "UK", "DE", "US")
 *
 * @example
 * ```typescript
 * getDefaultCountry("en_GB") // Returns "UK"
 * getDefaultCountry("de_DE") // Returns "DE"
 * getDefaultCountry() // Returns "US" (default fallback)
 * ```
 */
const getDefaultCountry = (locale) => {
    const defaults = (0, exports.getDefaults)(locale);
    return defaults.country_code;
};
exports.getDefaultCountry = getDefaultCountry;
/**
 * Get the default IANA timezone for a given locale.
 * Falls back to "America/Los_Angeles" if the locale is not found.
 *
 * @param locale - Optional locale string (e.g., "en_GB", "de_DE")
 * @returns IANA timezone identifier (e.g., "Europe/London", "Europe/Berlin")
 *
 * @example
 * ```typescript
 * getDefaultTimezone("en_GB") // Returns "Europe/London"
 * getDefaultTimezone("de_DE") // Returns "Europe/Berlin"
 * getDefaultTimezone() // Returns "America/Los_Angeles" (default fallback)
 * ```
 */
const getDefaultTimezone = (locale) => {
    const defaults = (0, exports.getDefaults)(locale);
    return defaults.default_timezone;
};
exports.getDefaultTimezone = getDefaultTimezone;
//# sourceMappingURL=defaults.js.map